import { forwardRef } from 'react';
import { cn } from '@/libs/tailwind';

export type InputProps = {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  containerClassName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ containerClassName, className, type, label, helperText, errorMessage, disabled, ...props }, ref) => {
    return (
      <div className={cn('flex flex-col', containerClassName)}>
        {label && (
          <label
            className={cn(
              'mb-2 text-body-md font-medium text-fg-primary',
              errorMessage && 'text-interactive-negative',
            )}
          >
            {label}
          </label>
        )}
        <input
          type={type}
          disabled={disabled}
          className={cn(
            'flex w-full rounded-lg border-0.5 border-fg-border bg-bg-surface-primary px-3 text-body-md text-fg-primary placeholder:text-fg-secondary h-10 outline-hidden',
            'hover:border-fg-secondary active:border active:border-fg-primary focus:border-fg-primary focus:border',
            errorMessage && 'border-interactive-negative focus:border-interactive-negative hover:border-interactive-negative active:border-interactive-negative',
            disabled && 'bg-bg-disabled text-fg-disabled hover:border-fg-border active:border-fg-border placeholder:text-fg-disabled',
            type === 'date' && 'cursor-pointer [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-moz-calendar-picker-indicator]:cursor-pointer [&::-ms-clear]:cursor-pointer [&::calendar-picker-indicator]:cursor-pointer',
            type === 'search' && 'pl-10 [&::-webkit-search-cancel-button]:appearance-none',
            className,
          )}
          ref={ref}
          {...props}
        />
        {errorMessage && <p className="text-interactive-negative text-body-md mt-2">{errorMessage}</p>}
        {(helperText && !errorMessage) && <p className="text-fg-primary text-body-md mt-2">{helperText}</p>}
      </div>
    );
  },
);

Input.displayName = 'Input';

export { Input };
